import api from '../../../../utilities/interseptor';
import { extraerHora } from '../../../../utilities/formateos';

const apiUrl = process.env.REACT_APP_API;

export const getDataMapa = async (idBitacora, setTrazo, setDataModal) => {
    try {
        const res = await api.get(`${apiUrl}/monitor/incidencias/detalle-trazo`, {
            params: { id_bitacora: idBitacora },
        });
        const d = res.data;

        setDataModal({
            ruta:                 d.NOMBRE_RUTA,
            operador:             d.CHOFER,
            asientos_disponibles: d.ASIENTOS_DISPONIBLES,
            unidad:               d.ID_UNIDAD,
            capacidad:            d.CAPACIDAD,
            personas:             d.PASAJEROS,
            hora_inicio:          d.HORA_ARRANQUE,
            hora_fin:             d.HORA_LLEGADA,
            hora_arranque:        d.HORA_INICIO_WIALON ?? d.HORA_INICIO_RUTA,
            hora_fin_real:        d.HORA_FINAL_RUTA,
            horaDeInicio:         extraerHora(d.HORA_ARRANQUE),
            horaLlegada:          extraerHora(d.HORA_LLEGADA),
            id_bitacora:          d.ID_BITACORA,
        });

        setTrazo({
            markers:       d.TRAZO?.markers ?? [],
            trazo:         d.TRAZO?.polyline?.trazo ?? [],
            trazo_waillon: d.TRAZO_WAILLON?.trazo ?? [],
            stops_wiallon: d.TRAZO_WAILLON?.stops ?? [],
            enProceso:     d.TRAZO_WAILLON?.RUTA_EN_PROCESO ?? false,
        });
    } catch (error) {
        console.error('getDataMapa', error);
    }
};

export const posicionUnidad = async (unidad = '', setData) => {
    try {
        const res = await api.get(`${apiUrl}/aforo/unidades/posicion`, {
            params: { id_unidad_wailon: unidad },
        });
        setData(res.data);
    } catch (error) {
        console.error('posicionUnidad', error);
    }
};
